import React from "react";

const schools = [
    {
        id: 1,
        name: "school-of-management",
        metatitle: "ISBM School of Management | Management Program courses",
        metadesc: "Transform your career with ISBM University's School of Management. Explore management programs, expert faculty, industry-focused curriculum and excellent career opportunities."
    },
    {
        id: 2,
        name: "school-of-science",
        metatitle: "School of Science - ISBM University Programs & Careers",
        metadesc: "Explore the School of Science at ISBM University. Gain insights into undergraduate, postgraduate and research programs designed for future scientists."
    },
    {
        id: 3,
        name: "school-of-commerce",
        metatitle: "ISBM Is The Top University in India For The School of Commerce",
        metadesc: "School of Commerce offers innovative business education, fostering excellence in accounting, finance, economics and entrepreneurship."
    },
    {
        id: 4,
        name: "school-of-arts-and-humanities",
        metatitle: "School of Arts and Humanities - Apply Now at ISBM",
        metadesc: "Join the School of Arts and Humanities at ISBM University. Discover programs in languages, history, sociology, political science and more."
    },
    {
        id: 5,
        name: "school-of-engineering-and-technology",
        metatitle: "School of Engineering and Technology | Apply Now",
        metadesc: "Discover the School of Engineering and Technology at ISBM University. Learn through modern labs, experienced faculty and industry-oriented programs."
    },
    {
        id: 6,
        name: "school-of-information-and-technology",
        metatitle: "School of Information and Technology | Join us today",
        metadesc: "The School of Information and Technology at ISBM University offers cutting-edge programs in Computer Science, AI, Data Science and emerging technologies."
    },
    {
        id: 7,
        name: "school-of-design",
        metatitle: "School of Design at ISBM University - Join Now!",
        metadesc: "Discover the School of Design at ISBM University. Unlock your creativity through Fashion Design, Interior Design and Product Design programs."
    },
    {
        id: 8,
        name: "school-of-pharmacy",
        metatitle: "School of Pharmacy at ISBM University | Apply now",
        metadesc: "School of Pharmacy offers comprehensive education in pharmaceutical sciences with practical exposure and research opportunities."
    },
    {
        id: 9,
        name: "school-of-life-science",
        metatitle: "Spot Your Place In Our School Of Life Science | ISBM University",
        metadesc: "Explore microbiology and biotechnology at the School of Life Science with research-driven learning and modern laboratory facilities."
    },
    {
        id: 10,
        name: "school-of-yoga-and-naturopathy",
        metatitle: "Best Yoga & Naturopathy School | ISBM University",
        metadesc: "Discover the transformative power of Yoga and Naturopathy at ISBM University through holistic education and wellness-focused programs."
    },
    {
        id: 11,
        name: "school-of-law",
        metatitle: "Welcome to the School of Law at ISBM University | Apply Now",
        metadesc: "Welcome to the School of Law at ISBM University. Apply now for integrated law, LLB, LLM and doctoral programs."
    },
    {
        id: 12,
        name: "school-of-library-and-information-science",
        metatitle: "School of Library and Information Science | ISBM University",
        metadesc: "Join the School of Library and Information Science at ISBM University to build expertise in modern library systems and information management."
    },
    {
        id: 13,
        name: "school-of-journalism-and-mass-communication",
        metatitle: "School of Journalism and Mass Communication | Join us today",
        metadesc: "Elevate your career with the School of Journalism and Mass Communication through practical media education and industry exposure."
    },
    {
        id: 14,
        name: "school-of-education",
        metatitle: "Apply today to secure your spot in School of Education",
        metadesc: "School of Education at ISBM University offers programs grounded in modern teaching methodologies and educational excellence."
    },
    {
        id: 15,
        name: "school-of-hotel-management",
        metatitle: "Boost Your Career At The School of Hotel Management",
        metadesc: "Boost your career with our School of Hotel Management programs focused on hospitality, tourism and service excellence."
    },
    {
        id: 16,
        name: "school-of-health-and-allied-science",
        metatitle: "School of Health and Allied Science | ISBM University",
        metadesc: "Explore the School of Health and Allied Science to pursue a rewarding career in healthcare, diagnostics and allied medical sciences."
    },
    {
        id: 17,
        name: "school-of-vocational-management",
        metatitle: "ISBM School of Vocational Management | ISBM Vocational Program",
        metadesc: "Explore ISBM University's School of Vocational Management, designed to provide industry-relevant skills and career-oriented education."
    },
    {
        id: 18,
        name: "school-of-media-and-entertainment",
        metatitle: "School of Media and Entertainment | ISBM University",
        metadesc: "School of Media and Entertainment at ISBM University. Explore filmmaking, digital media, broadcasting and entertainment studies."
    }
];

function MetaInfo({ schoolDetails }) {
    const school =
        schools.find((item) => item.name === schoolDetails) || schools[0];

    return (
        <>
            <title>{school.metatitle}</title>

            <meta name="description" content={school.metadesc} />

            <meta
                property="og:title"
                content={school.metatitle}
            />

            <meta
                property="og:description"
                content={school.metadesc}
            />

            <meta
                property="og:url"
                content={`https://isbmuniversity.edu.in/${school.name}`}
            />

            <meta
                property="og:image"
                content="https://isbmuniversity.edu.in/static/media/commb.0f9333e0.webp"
            />

            <meta property="og:image:alt" content="ISBM University" />
            <meta property="og:type" content="website" />
            <meta property="og:site_name" content="ISBM University" />

            <meta
                name="twitter:title"
                content={school.metatitle}
            />

            <meta
                name="twitter:description"
                content={school.metadesc}
            />

            <meta
                name="twitter:image"
                content="https://isbmuniversity.edu.in/static/media/commb.0f9333e0.webp"
            />

            <meta name="twitter:card" content="summary_large_image" />
        </>
    );
}

export default MetaInfo;